import PropTypes from 'prop-types';
import React from 'react';

const LimitsPage = ({ ivg, declar }) => (
    <div className="page">
        <span>Dates limites</span>
        <div>
            <span>Délais IVG</span>
            <span>{`${ivg} (14 SA)`}</span>
        </div>
        <div>
            <span>Déclaration grossesse (max)</span>
            <span>{`${declar} (16 SA)`}</span>
        </div>
    </div>
);

LimitsPage.propTypes = {
    ivg: PropTypes.string.isRequired,
    declar: PropTypes.string.isRequired,
};
export default LimitsPage;
